import * as React from 'react';
const FilterDropdownMenuWrapper = (props) => {
    return (<div className={props.className} onClick={e => e.stopPropagation()}>
        {props.children}
    </div>);
};
export default FilterDropdownMenuWrapper;
